import { useParams, useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import { useMemo } from 'react';

export const setQuery = (params: { [key: string]: string | number }) => qs.stringify(params, { addQueryPrefix: true });

export default function useRouter() {
	const params = useParams();
	const location = useLocation();
	const history = useHistory();

	// Return our custom router object
	// Memoize so that a new object is only returned if something changes
	return useMemo(() => {
		const query: { [key: string]: string } = {
			...qs.parse(location.search, { ignoreQueryPrefix: true }), // Convert string to object
			...params,
		};
		return {
			// For convenience add push(), replace(), pathname at top level
			push: history.push,
			replace: history.replace,
			pathname: location.pathname,
			// Merge params and parsed query string into single "query" object
			// so that they can be used interchangeably.
			// Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
			query,
			// Include match, location, history objects so we have
			// access to extra React Router functionality if needed.
			location,
			history,
		};
	}, [params, location, history]);
}
